<mat-card class="fuse-card-xlarge">

    <mat-card-content>
        <div style="display: flex;">

            <div style="margin-top:1.4rem;margin-left:0.8rem">
                <h4><label translate>USER_TYPE</label>: <span class="text-bold" translate>AMAZON_DSP_USER</span></h4>

            </div>

        </div>
    </mat-card-content>
</mat-card>
